import { gsap } from 'gsap';
import { Flip } from 'gsap/Flip';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { createStableResizeHandler } from '../viewport-utils';

gsap.registerPlugin(Flip, ScrollTrigger);

export default function initAnimation(
    root: HTMLElement,
    lineContainer: HTMLElement,
    firstLine: HTMLElement,
    secondLine: HTMLElement,
    demoLinesContainer: HTMLElement,
    demoLineLeft: HTMLElement,
    demoLineRight: HTMLElement,
    demoLineLeftTarget: HTMLElement,
    demoLineRightTarget: HTMLElement,
    autoPlay: HTMLElement,
) {
    ScrollTrigger.create({
        trigger: root,
        start: 'top top',
        end: '+=150%',
        pin: true,
        scrub: true,
        // markers: {
        //     startColor: 'white',
        //     endColor: 'white',
        //     indent: 100,
        // },
    });

    initFirstLineAnimation(root, firstLine);
    initSecondLineAnimation(root, secondLine);

    gsap.set(autoPlay, { scale: 0.2, opacity: 0, transformOrigin: 'center' });

    const cleanupChatDemoAnimation = initChatDemoAnimation(
        root,
        demoLineLeft,
        demoLineLeftTarget,
        demoLineRight,
        demoLineRightTarget,
        autoPlay,
    );

    return cleanupChatDemoAnimation;
}

let leftFlipCtx: gsap.Context | null = null;
let rightFlipCtx: gsap.Context | null = null;

function initChatDemoAnimation(
    root: HTMLElement,
    demoLineLeft: HTMLElement,
    demoLineLeftTarget: HTMLElement,
    demoLineRight: HTMLElement,
    demoLineRightTarget: HTMLElement,
    autoPlay: HTMLElement,
) {
    const createLeftLineTimeline = () => {
        leftFlipCtx && leftFlipCtx.revert();

        leftFlipCtx = gsap.context(() => {
            const secondState = Flip.getState(demoLineLeftTarget);
            const flipConfig = {
                ease: 'power1.inOut',
                duration: 1,
            };

            const tl = gsap.timeline({
                scrollTrigger: {
                    trigger: root,
                    start: 'top top',
                    end: '+=150%',
                    scrub: true,
                    // markers: true,
                },
            });

            const flipFit = Flip.fit(
                demoLineLeft,
                secondState,
                flipConfig,
            ) as gsap.core.Tween;

            tl.add(flipFit);
        });
    };

    const createRightLineTimeline = () => {
        rightFlipCtx && rightFlipCtx.revert();

        rightFlipCtx = gsap.context(() => {
            const secondState = Flip.getState(demoLineRightTarget);
            const flipConfig = {
                ease: 'power1.inOut',
                duration: 1,
            };

            const tl = gsap.timeline({
                scrollTrigger: {
                    trigger: root,
                    start: 'top top',
                    end: '+=150%',
                    scrub: true,
                    // markers: true,
                },
            });

            const flipFit = Flip.fit(
                demoLineRight,
                secondState,
                flipConfig,
            ) as gsap.core.Tween;

            tl.add(flipFit);
        });
    };

    createLeftLineTimeline();
    createRightLineTimeline();

    // const debouncedLeftTimeline = debounce(createLeftLineTimeline);
    // const debouncedRightTimeline = debounce(createRightLineTimeline);

    const handleResize = createStableResizeHandler(() => {
        createLeftLineTimeline();
        createRightLineTimeline();
    });
    window.addEventListener('resize', handleResize);

    gsap.to(autoPlay, {
        scrollTrigger: {
            trigger: root,
            start: 'top top',
            end: '+=150%',
            scrub: true,
            // markers: {
            //     startColor: 'green',
            //     endColor: 'green',
            //     indent: 0,
            // },
        },
        scale: 1,
        opacity: 1,
    });

    return () => {
        window.removeEventListener('resize', handleResize);
        leftFlipCtx?.revert();
        rightFlipCtx?.revert();
        leftFlipCtx = null;
        rightFlipCtx = null;
    };
}

function initFirstLineAnimation(root: HTMLElement, firstLine: HTMLElement) {
    gsap.to(firstLine, {
        scrollTrigger: {
            trigger: root,
            start: 'top top',
            end: '+=15%',
            scrub: true,
            // markers: true,
        },
        autoAlpha: 0,
        y: -20,
    });
}

function initSecondLineAnimation(root: HTMLElement, secondLine: HTMLElement) {
    gsap.to(secondLine, {
        scrollTrigger: {
            trigger: root,
            start: 'top top',
            end: '+=25%',
            scrub: true,
            // markers: true,
        },
        autoAlpha: 0,
        y: -30,
    });
}
